<script>
  export default {
    name: "GroupColumns",

    render (h, { children, props, parent, scopedSlots }) {
      children = children.filter(el => el.data);
      const headerGroup = scopedSlots["header-group"];
      const sortIcon = (vnode) => h("b-icon", {
        attrs: {
          icon: parent?.$refs.table?.$refs.lTable.currentSortColumn.field === vnode.componentOptions.propsData.field
            ? parent.$refs.table.$refs.lTable.isAsc ? "sort-up" : "sort-down"
            : "sort",
          size: "is-small",
          class: "icon sort-icon is-relative is-inline ml-2",
          both: true
        }
      });

      return children.filter(el => el.data).map((vnode, idx) => {
        const { tooltip } = vnode.data.attrs;
        const { field, headerClass, sortable, thAttrs, cellClass } = vnode.componentOptions.propsData;
        const isFirst = idx === 0;
        const isSortable = sortable !== undefined;
        const headerClasses = isFirst ? "is-header is-pointer-none borderless" : "is-hidden";
        const isHeaderSlot = vnode.fnOptions?.name === "GroupColumn";

        if (!vnode.data.scopedSlots.subheading) {
          if (isSortable) {
            vnode.data.scopedSlots.subheading = isHeaderSlot ? vnode.data.scopedSlots.header : (props) => h(
              "LTooltip", {
                props: {
                  type: "is-dark",
                  label: tooltip,
                  active: !!tooltip
                },
                nativeOn: {
                  click: $event => {
                    const column = parent.$refs.table.$refs.lTable.newColumns.find((c) => c.field === field);
                    parent.$refs.table.$refs.lTable.sort(column, null, $event);
                  }
                }
              },
              [
                h("div", {
                    class: "th-wrap is-centered is-pointer nowrap"
                  },
                  [
                    h("span", props.column.label),
                    sortIcon(vnode)
                  ])
              ]);
          } else {
            vnode.data.scopedSlots.subheading = (props) => props.column.label;
          }
        }
        vnode.data.attrs = { index: idx, sortNamespace: props.sortNamespace, iconPath: props.iconPath };
        vnode.data.scopedSlots.header = isFirst ? () => headerGroup
          ? h("div", { on: { click: e => e.stopPropagation() }, class: props.customClass }, headerGroup(props))
          : props.labelGroup : () => {};
        vnode.componentOptions.propsData.thAttrs = isFirst ? () => ({ colspan: children.length, ...thAttrs?.() }) : thAttrs;
        vnode.componentOptions.propsData.headerClass = [headerClass, headerClasses, props.headerClass].filter(Boolean).join(" ");
        vnode.componentOptions.propsData.cellClass = [isFirst && props.shadow && "is-first", cellClass, props.cellClass].filter(Boolean).join(" ");
        vnode.componentOptions.propsData.centered = props.centered;

        return vnode;
      }).flat(1);
    },
    functional: true,

    props: {
      labelGroup: {
        type: String,
        required: true
      },

      centered: {
        type: Boolean,
        default: false
      },

      shadow: {
        type: Boolean,
        default: true
      },

      headerClass: {
        type: String,
        default: null
      },

      cellClass: {
        type: String,
        default: null
      },

      customClass: {
        type: String,
        default: null
      },

      sortNamespace: {
        type: String,
        default: null
      },

      iconPath: {
        type: String,
        default: "assets/common"
      }
    }
  };
</script>

<style scoped>

</style>